import React from 'react'
import styled from 'styled-components'

// Components
import { Link, Button, ErrorMessage } from '@sketch/components'
import WorkspaceSidebarLayout from '../../components/WorkspaceSidebarLayout'

// Constants
import { routes } from '@sketch/constants'

// Icons
import { ReactComponent as WorkspaceIcon } from '@sketch/icons/workspace-64-svg'
import { ReactComponent as GlobeIcon } from '@sketch/icons/globe-64-svg'

// Types
import { useGetInitialUserQuery } from '@sketch/gql-types'

const StyledErrorMessage = styled(ErrorMessage)<{ isPartner?: boolean }>`
  height: auto;
  max-width: ${({ isPartner }) => (isPartner ? '542px' : '480px')};
  flex: 1 0 auto;
  align-self: center;
  padding: 16px;
`

interface NoWorkspaceViewProps {
  title?: string
  additionalMessage?: React.ReactNode
}

export const NoWorkspaceView: React.FC<NoWorkspaceViewProps> = () => {
  const { data } = useGetInitialUserQuery()
  const isParner = data?.me.isPartner

  return (
    <WorkspaceSidebarLayout
      title="No Workspaces"
      workspaces={[]}
      currentWorkspace={undefined}
    >
      {isParner ? (
        <StyledErrorMessage
          title="You’re now a Sketch Partner"
          icon={<GlobeIcon />}
          isPartner
        >
          As a Sketch Partner, you can join Workspaces, and manage billing
          details and Editor Seats on behalf of your clients.
        </StyledErrorMessage>
      ) : (
        <StyledErrorMessage
          title="Create your first Workspace"
          icon={<WorkspaceIcon />}
          extra={
            <Link
              to={{
                pathname: routes.WORKSPACE_CREATE.create({}),
                state: { fromNoWorkspaces: true },
              }}
            >
              <Button variant="primary">Create Workspace</Button>
            </Link>
          }
        >
          Saved documents will display here. Kick off your{' '}
          <b>30-day free trial</b> by creating your first Workspace!
        </StyledErrorMessage>
      )}
    </WorkspaceSidebarLayout>
  )
}
